import { Alert, Avatar, Box, Button, Paper, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [form, setForm] = useState({
    name: "",
    newPassword: "",
    confirmPassword: ""
  })

  const handleChange = (event) => {
    const { value, name } = event.target;
    setForm({ ...form, [name]: value });
  }

  const navigate = useNavigate();

  const handleForget = () => {
    // Traditional validation
    if (form.newPassword !== form.confirmPassword) {
      setAlertMessage("Passwords do not match!");
      setAlertSeverity("error");
      setShowAlert(true);
      return;
    }

    axios.post("http://localhost:8081/auth/forgot-password", form)
      .then((response) => {
        const { status, message } = response.data;
        if (status === "OK") {
          setAlertMessage(message); // e.g., "Password reset successfully!"
          setAlertSeverity("success");
          setShowAlert(true);

          setTimeout(() => {
            navigate("/login"); // Navigate to Login page after 3 seconds
          }, 1000);
        } else {
          setAlertMessage(message || "Something went wrong.");
          setAlertSeverity("error");
          setShowAlert(true);
        }
      })
      .catch((error) => {
        const errMsg = error.response?.data?.message || "Password reset failed";
        setAlertMessage(errMsg);
        setAlertSeverity("error");
        setShowAlert(true);
      });
  };

  return (
    <Box sx={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Paper elevation={3} sx={{
        width: "25%",
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
        padding: 2,
        border: "2px solid purple", // Paper border color
        borderRadius: "8px",         // optional for smooth corners
      }}>

        <Avatar sx={{
          bgcolor: "purple" // Avatar background color
        }} src="/broken-image.jpg" />

        <Typography variant="h5" gutterBottom>FORGET PASSWORD</Typography>

        {showAlert && (
          <Alert severity={alertSeverity} sx={{ position: "absolute", top: 10, width: "30%" }}>
            {alertMessage}
          </Alert>
        )}

        <TextField
          label="User Name"
          variant="outlined"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "purple", // Hover color purple
              },
              "&.Mui-focused fieldset": {
                borderColor: "purple", // Focus color purple
              }
            }
          }}
        />

        <TextField
          label="New Password"
          variant="outlined"
          type="password"
          name='newPassword'
          value={form.newPassword}
          onChange={handleChange}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "purple",
              },
              "&.Mui-focused fieldset": {
                borderColor: "purple",
              }
            }
          }}
        />

        <TextField
          label="Confirm Password"
          variant="outlined"
          type="password"
          name='confirmPassword'
          value={form.confirmPassword}
          onChange={handleChange}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "purple",
              },
              "&.Mui-focused fieldset": {
                borderColor: "purple",
              }
            }
          }}
        />

        <Button
          variant="contained"
          onClick={handleForget}
          sx={{
            backgroundColor: "purple",
            "&:hover": {
              backgroundColor: "darkviolet" // darker purple on hover
            }
          }}
        >
          CHANGE PASSWORD
        </Button>

      </Paper>
    </Box>
  );
};

export default ForgetPassword;
